import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f4cd91e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sales-ratio-hint-banner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "#d48806",
  class: "hint-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hint-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "匹配优先级规则："),
  /*#__PURE__*/_createTextVNode("特殊政策提交时，系统优先校验【客户占比管控白名单】，若客户在白名单内则跳过所有校验；若不在，则按精确度从高到低匹配管控规则："),
  /*#__PURE__*/_createElementVNode("strong", null, "① 渠道+省区+销售办公室+客户"),
  /*#__PURE__*/_createTextVNode(" → "),
  /*#__PURE__*/_createElementVNode("strong", null, "② 渠道+省区+销售办公室"),
  /*#__PURE__*/_createTextVNode(" → "),
  /*#__PURE__*/_createElementVNode("strong", null, "③ 渠道+省区"),
  /*#__PURE__*/_createTextVNode(" → "),
  /*#__PURE__*/_createElementVNode("strong", null, "④ 渠道"),
  /*#__PURE__*/_createTextVNode("。找到最精确匹配行后，直接使用该行全部阈值。 ")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}